import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.5 5c.665 0 1.279.352 1.616.928L28.242 23.18c.342.582.342 1.299.01 1.88a1.88 1.88 0 0 1-1.627.942H6.373c-.67 0-1.293-.36-1.626-.942a1.88 1.88 0 0 1 .01-1.88L14.881 5.93A1.87 1.87 0 0 1 16.499 5m0 6c-.624 0-1.126.502-1.126 1.126v5.25c0 .623.502 1.125 1.125 1.125.624 0 1.125-.502 1.125-1.125v-5.25c0-.624-.501-1.126-1.125-1.126M18 21.501c0-.83-.671-1.5-1.5-1.5-.83 0-1.501.67-1.501 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5"
    }, null, -1)
  ]))]))
}
export default { render: render }